import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { history } from 'mobile_web/modules/navigation/history'
import { sentryEnvironment } from 'mobile_web/modules/logging'
import { dropChunkFailureWhileOffline, registerPreloadErrorHandler } from 'mobile_web/modules/logging/preloadError'
import { registerServiceWorker } from 'mobile_web/sw/register'
import App from './App.tsx'
import './index.css'

const environment = sentryEnvironment()
if (environment !== 'development') {
	Sentry.init({
		dsn: ENV.SENTRY_DSN,
		integrations: [Sentry.browserTracingIntegration(), Sentry.reactRouterV5BrowserTracingIntegration({ history })],
		tracesSampleRate: 0.01,
		environment,
		// Vite's rethrow cannot be kept off the global handler without handing the import's callers `undefined`.
		beforeSend: dropChunkFailureWhileOffline,
	})

	// Inside the guard: with Sentry off the handler reports nothing, but its cancel still hides a failed stylesheet.
	registerPreloadErrorHandler()
}

createRoot(document.getElementById('root')!).render(<App />)

// Defer registration until after the first render.
void registerServiceWorker()
